<template>
  <div>
    <Breadcrumb msg1="处方管理" msg2="处方详情" />
    <el-card v-if="data.prescription">
      <div style="margin-bottom: 10px">
        <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="处方号">{{ data.prescription.prescriptionNo }}</el-descriptions-item>
        <el-descriptions-item label="客户">{{ customerName(data.prescription.customerId) }}</el-descriptions-item>
        <el-descriptions-item label="类型">{{ data.prescription.prescriptionType }}</el-descriptions-item>
        <el-descriptions-item label="诊断">{{ data.prescription.diagnosis }}</el-descriptions-item>
        <el-descriptions-item label="开具日期">{{ data.prescription.issueDate }}</el-descriptions-item>
        <el-descriptions-item label="有效期(天)">{{ data.prescription.validDays }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag :type="data.prescription.status === '已作废' ? 'danger' : 'success'">{{ data.prescription.status }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="签名">{{ data.prescription.signature }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ data.prescription.remark }}</el-descriptions-item>
      </el-descriptions>
      <el-table :data="data.items" border size="small" style="margin-top: 15px">
        <el-table-column type="index" label="序号" width="60"></el-table-column>
        <el-table-column label="类型" prop="itemType"></el-table-column>
        <el-table-column label="名称" prop="itemName"></el-table-column>
        <el-table-column label="规格" prop="spec"></el-table-column>
        <el-table-column label="数量" prop="quantity" width="80"></el-table-column>
        <el-table-column label="单位" prop="unit" width="80"></el-table-column>
        <el-table-column label="用法" prop="usage"></el-table-column>
        <el-table-column label="单价" prop="price" width="90"></el-table-column>
        <el-table-column label="金额" prop="amount" width="90"></el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      id: this.$route.params.id,
      data: { prescription: null, items: [] }
    }
  },
  created () {
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get(`/prescriptions/${this.id}`).then(res => {
      if (res.data.status === 200) {
        this.data = { prescription: res.data.data.prescription, items: res.data.data.items || [] }
      } else {
        this.$message.error(res.data.message)
      }
    })
  },
  methods: {
    customerName
  }
}
</script>
